import React from 'react';
import block from 'bem-cn-lite';
import StatusesGroup from './StatusesGroup';
import CurrentStatus from './CurrentStatus';
import { TransitionGroup } from 'react-transition-group';
import { FadeTransition } from '../../Components/Transitions';
import store from '../state'
import createCustomEvent from '../../createCustomEvent'

class StatusMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpened: false,
            showCurrentTooltip: true,
            showCompleteTooltip: false,
            showSubmenuTooltip: false
        }

        this.showStatusSelect = this.showStatusSelect.bind(this)
        this.onStatusChange = this.onStatusChange.bind(this)
        this.onComplete = this.onComplete.bind(this)
        this.handleClickOutside = this.handleClickOutside.bind(this)

    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    showStatusSelect() {
        if(this.props.disabled) return false;
        var tooltips = {
            showCurrentTooltip: false,
            showSubmenuTooltip: false,
        }

        if(this.props.step === 0 && !this.props.isStatusChanges) {

            if(!this.state.isOpened) {
                tooltips.showSubmenuTooltip = true
            } else {
                tooltips.showCurrentTooltip = true
            }
            
        } else if(this.props.step === 3 && this.state.isOpened) {
            tooltips.showCurrentTooltip = true
        }

        this.setState({
            ...tooltips,
            isOpened: !this.state.isOpened
        })
    }

    onStatusChange(id) {
        this.setState({
            isOpened: false
        });

        let step = this.props.step;
        let newStatus = this.props.getStatusById(id)

        switch(this.props.step) {
            case 0:
                if(newStatus.isComplete) {
                    step = 3;
                } else {
                    step = 1;
                    this.setState({
                        showCompleteTooltip: true
                    })
                }

                break;
            case 1:
                if(newStatus.isComplete) {
                    step = 2;
                    this.setState({
                        showCompleteTooltip: false
                    })
                }
                break;

            case 3:
                if(!newStatus.isComplete) {
                    step = 2;
                    this.setState({
                        showCompleteTooltip: false
                    })
                }
                break;
            default:
                break;
        }

        this.props.setGlobalState({
            currentStatus: id,
            isStatusChanges: true,
            step: step
        });

        window.dispatchEvent(createCustomEvent('IS_CUSTOM_WORKFLOW__STATUS_CHANGED', { detail: { status: newStatus.name } }));
    }

    onComplete() {
        var currentStatus = this.props.getCurrentStatus()

        var finalTask = this.props.statuses.find(status => status.category === currentStatus.category && status.isComplete)

        if(finalTask) {
            this.onStatusChange(finalTask.id)
        }
    }

    handleClickOutside(event) {
        if (this.menuRef && !this.menuRef.contains(event.target) && this.state.isOpened) {
            this.showStatusSelect()
        }
    }

    render() {
        const b = block('StatusMenu');

        const currentStatus = this.props.getCurrentStatus();

        const categories = this.props.categories.sort((current, next) => {
            return (next.id === currentStatus.category) - (current.id === currentStatus.category)
        })

        return (
            <div className={b()} ref={(input) => { this.menuRef = input; }}>
                <div className={b('current')}>
                    <CurrentStatus
                        status={currentStatus}
                        disabled={this.props.disabled}
                        onStatusSelectClick={this.showStatusSelect}
                        onCompleteClick={this.onComplete}
                        showCurrentTooltip={this.state.showCurrentTooltip}
                        showCompleteTooltip={this.state.showCompleteTooltip}
                    />
                </div>
                <TransitionGroup>
                        {
                            this.state.isOpened &&
                            <FadeTransition>
                                <div className={b('list', { opened: true })}>
                                    {categories.map((cat) =>
                                        <StatusesGroup
                                            id={cat.id}
                                            key={cat.id}
                                            isActive={cat.id === currentStatus.category}
                                            group={cat}
                                            currentStatus={this.props.currentStatus}
                                            statusesList={this.props.getStatusByCategory(cat.id)}
                                            showTooltip={this.state.showSubmenuTooltip && this.props.categoryTooltipId === cat.id}
                                            showCompleteTooltip={this.state.showCompleteTooltip}
                                            onStatusSelect={this.onStatusChange}
                                        /> 
                                    )}
                                </div>
                            </FadeTransition>
                        }
                </TransitionGroup>
            </div> 
        )
    }
}

export default store(StatusMenu)